import { DatabaseCloseRoutesLogRepository } from "@domain/repositories/DatabaseCloseRoutesLogRepository";
import { UserStore } from "@domain/stores/UserStore";
import UseCase from "@domain/UseCase";
import { userRoles } from "@domain/models/User";

type Input = void;

type Output = void;

export class WatchCloseRoutesLogsUseCase implements UseCase<Input, Output> {
  constructor(
    private readonly userStore: UserStore,
    private readonly closeRoutesLogRepository: DatabaseCloseRoutesLogRepository
  ) {}

  execute() {
    const user = this.userStore.user;

    if (user.role === userRoles.root || user.role === userRoles.admin) {
      this.closeRoutesLogRepository.watchCloseRoutesLogsAdmin();
    }

    return;
  }
}
